<template>
        <v-card color="white" width="100%">
            <v-toolbar color="amber">
                <v-btn icon @click="Close"> <v-icon>mdi-close</v-icon></v-btn>
                <v-toolbar-title class="font-weight-black" v-if="edit == true">Edit Party</v-toolbar-title>
                 <v-toolbar-title class="font-weight-black" v-else>New Party</v-toolbar-title>
                    <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-btn color="black" class="amber--text" @click="save()">Save</v-btn>
                </v-toolbar-items>
            </v-toolbar>
            <v-form class="pa-5">
                    <v-row dense>
                        <v-col md=6 sm=6 cols=12 class="py-0">
                            <v-text-field v-model="name" label="Party Name" outlined color="amber"></v-text-field>
                        </v-col>
                        <v-col md=6 sm=6 cols=12 class="py-0">
                            <v-text-field v-model="location" label="Location" outlined color="amber"></v-text-field>
                        </v-col>
                    </v-row>
                   
            </v-form> 

        <span style="display:none;">{{checkfetch}}</span>
        </v-card>
</template>

<script>
import { SERVER_API } from "../../../API";
export default {
    props:['id','edit'],
    data(){
        return{
            name:'',
            location:'',
        }
    },
    computed:{
        checkfetch(){
            return this.fetchById();
        }
    },
    methods:{
         reset(){
            this.name = '';
            this.location = '';
        },
        Close(){
            this.reset();
            this.$emit('Close',false);
        },
        async fetchById(){
            if(this.edit == true){
                const response = await this.$http.get(SERVER_API+'/broker/party/byid/'+this.id);
                this.name = response.data.data.name
                this.location = response.data.data.location
            }
        },
        async save(){
            if(this.edit == true){
                try{
                    const response = await this.$http.put(SERVER_API+'/broker/party/update',{
                        id:this.id,
                        name: this.name,
                        location: this.location
                        
                    });
                    this.$emit('Response',response.data);
                }catch(error){
                    this.$emit('Response',error);
                }
            }else{
                try{
                    const response = await this.$http.post(SERVER_API+'/broker/party/create',{
                        name: this.name,
                        location: this.location,
                    });
                    this.$emit('Response',response.data);
                }catch(error){
                    this.$emit('Response',error);
                }
            }
        }
    }

}
</script>

<style>

</style>